<template>
  <div class="issue-source-table-cell">
    {{getSource}}
  </div>
</template>

<script>
export default {
  name: 'IssueSourceTableCell',
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
  computed: {
    getSource() {
      if (this.item?.metaData?.testSource) {
        return this.$t(`test.testType.${this.item.metaData.testSource}`);
      }
      return this.$t(`test.testType.${this.getAlternativeTestSource}`);
    },
    getAlternativeTestSource() {
      let result = '';
      switch (this.item.name) {
      case 'Exposed Cloud Asset':
      case 'Exposed Cloud Bucket':
      case 'Vulnerable Technology Found':
      case 'Asset Not Behind Waf':
      case 'Vulnerability Found on Asset':
        result = 'discovery';
        break;
      case 'Leak Credentials For Employee':
        result = 'employees';
        break;
      case 'Data Leak Discovered':
        result = 'dataleaks';
        break;
      case 'CVE Found on Host':
        result = 'autoexploitation';
        break;
      case 'Validated Leak Credential For Employee':
        result = 'autoexploitation';
        break;
      default:
        result = 'unknown';
      }
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';

.issue-source-table-cell {
  max-height: rem(48);
  font-family: $font-family-regular;
  color: var(--text-primary);
  font-size: rem(14);
  letter-spacing: 0;
  line-height: rem(16);
  overflow: hidden;
  display: flex;
  align-items: center;
  margin-top: rem(5);
}
</style>
